/**
 * Fleet CC DCRP Recovery API
 * Connected Claims Damaged Container Recovery APIs used for handling recovery data.
 *
 * OpenAPI spec version: 1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */ /* tslint:disable:no-unused-variable member-ordering */

import { Injectable } from '@angular/core';
import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';

import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { InsightsFilter } from '../models/insightsFilter';
import { CompletedBookings } from '../models/completedBookings';
import { ContainerRepairCost } from '../models/containerRepairCost';
import { ContainerVolumeWithNWithoutCP } from '../models/containerVolumeWithNWithoutCP';
import { WorkOrders } from '../models/workOrders';
import { DamageCostContainer } from '../models/damageCostContainer';
import { CommodityCost } from '../models/commodityCost';
import { RepairCost } from '../models/repairCost';
import { PaymentStatus } from '../models/paymentStatus';
import { InvoiceCount } from '../models/invoiceCount';
import { InvoiceCostUSD } from '../models/invoiceCostUSD';
import { DamageCostEquipmentType } from '../models/damageCostEquipmentType';
import { DamageCostEquipmentSize } from '../models/damageCostEquipmentSize';
import { ContainerWithCPType } from '../models/containerWithCPType';
import { ContainerShipper } from '../models/containerShipper';
import { ContainersDamaged } from '../models/containersDamaged';
import { InsightsRecoveryCaseFilter } from '../models/insightsRecoveryCaseFilter';
import { InsightsRecoveryCase } from '../models/insightsRecoveryCase';
import { CustomerInsights, DamagerCost, InsightsFilterV1 } from '../models';

@Injectable()
export class CPInsightsService {
  protected basePath = environment.ccdcrp_api_base_url;
  public defaultHeaders = new HttpHeaders();

  constructor(protected httpClient: HttpClient) {}

  /**
   * @param consumes string[] mime-types
   * @return true: consumes contains 'multipart/form-data', false: otherwise
   */
  private canConsumeForm(consumes: string[]): boolean {
    const form = 'multipart/form-data';
    for (const consume of consumes) {
      if (form === consume) {
        return true;
      }
    }
    return false;
  }

  /**
   * Get Completed Bookings Count
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsCompletedBookingsCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<CompletedBookings>;
  public cpInsightsCompletedBookingsCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<CompletedBookings>>;
  public cpInsightsCompletedBookingsCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<CompletedBookings>>;
  public cpInsightsCompletedBookingsCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<CompletedBookings>(
      'post',
      `${this.basePath}/cp-insights/completed-bookings-count`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Container Count by Repair Cost (USD)
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsContainerCountByRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContainerRepairCost>>;
  public cpInsightsContainerCountByRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContainerRepairCost>>>;
  public cpInsightsContainerCountByRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContainerRepairCost>>>;
  public cpInsightsContainerCountByRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<ContainerRepairCost>>(
      'post',
      `${this.basePath}/cp-insights/container-count-by-repair-cost`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get Container Volume With CP
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsContainerVolumeWithCpPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContainerVolumeWithNWithoutCP>;
  public cpInsightsContainerVolumeWithCpPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContainerVolumeWithNWithoutCP>>;
  public cpInsightsContainerVolumeWithCpPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContainerVolumeWithNWithoutCP>>;
  public cpInsightsContainerVolumeWithCpPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<ContainerVolumeWithNWithoutCP>(
      'post',
      `${this.basePath}/cp-insights/container-volume-with-cp`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get Containers Damaged
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsContainersDamagedPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<ContainersDamaged>;
  public cpInsightsContainersDamagedPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<ContainersDamaged>>;
  public cpInsightsContainersDamagedPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<ContainersDamaged>>;
  public cpInsightsContainersDamagedPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<ContainersDamaged>(
      'post',
      `${this.basePath}/cp-insights/containers-damaged`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get Container Volume by Shippers
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsContainersVolumeByShipperPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContainerShipper>>;
  public cpInsightsContainersVolumeByShipperPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContainerShipper>>>;
  public cpInsightsContainersVolumeByShipperPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContainerShipper>>>;
  public cpInsightsContainersVolumeByShipperPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);
    return this.httpClient.request<Array<ContainerShipper>>(
      'post',
      `${this.basePath}/cp-insights/containers-volume-by-shipper`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get CP Volume by Type
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsCpVolumeByTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<ContainerWithCPType>>;
  public cpInsightsCpVolumeByTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<ContainerWithCPType>>>;
  public cpInsightsCpVolumeByTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<ContainerWithCPType>>>;
  public cpInsightsCpVolumeByTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<ContainerWithCPType>>(
      'post',
      `${this.basePath}/cp-insights/cp-volume-by-type`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the damage cost grouped by equipment size.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsDamageCostEquipmentSizePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<DamageCostEquipmentSize>>;
  public cpInsightsDamageCostEquipmentSizePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<DamageCostEquipmentSize>>>;
  public cpInsightsDamageCostEquipmentSizePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<DamageCostEquipmentSize>>>;
  public cpInsightsDamageCostEquipmentSizePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<DamageCostEquipmentSize>>(
      'post',
      `${this.basePath}/cp-insights/damage-cost-equipment-size`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the damage cost grouped by equipment type.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsDamageCostEquipmentTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<DamageCostEquipmentType>>;
  public cpInsightsDamageCostEquipmentTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<DamageCostEquipmentType>>>;
  public cpInsightsDamageCostEquipmentTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<DamageCostEquipmentType>>>;
  public cpInsightsDamageCostEquipmentTypePost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<DamageCostEquipmentType>>(
      'post',
      `${this.basePath}/cp-insights/damage-cost-equipment-type`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the total invoice cost in USD, including total invoiced and missed amounts.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsInvoiceCostUsdPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<InvoiceCostUSD>;
  public cpInsightsInvoiceCostUsdPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<InvoiceCostUSD>>;
  public cpInsightsInvoiceCostUsdPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<InvoiceCostUSD>>;
  public cpInsightsInvoiceCostUsdPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<InvoiceCostUSD>(
      'post',
      `${this.basePath}/cp-insights/invoice-cost-usd`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Invoice Count
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsInvoiceCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<InvoiceCount>>;
  public cpInsightsInvoiceCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<InvoiceCount>>>;
  public cpInsightsInvoiceCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<InvoiceCount>>>;
  public cpInsightsInvoiceCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<InvoiceCount>>(
      'post',
      `${this.basePath}/cp-insights/invoice-count`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the invoice status based on the provided filter.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsInvoiceStatusPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<PaymentStatus>>;
  public cpInsightsInvoiceStatusPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<PaymentStatus>>>;
  public cpInsightsInvoiceStatusPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<PaymentStatus>>>;
  public cpInsightsInvoiceStatusPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<PaymentStatus>>(
      'post',
      `${this.basePath}/cp-insights/invoice-status`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the total repair cost for customers.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<RepairCost>;
  public cpInsightsRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<RepairCost>>;
  public cpInsightsRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<RepairCost>>;
  public cpInsightsRepairCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<RepairCost>(
      'post',
      `${this.basePath}/cp-insights/repair-cost`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get Top 10 Commodities By Cost
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsTop10CommoditiesByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<CommodityCost>>;
  public cpInsightsTop10CommoditiesByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<CommodityCost>>>;
  public cpInsightsTop10CommoditiesByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<CommodityCost>>>;
  public cpInsightsTop10CommoditiesByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);
    return this.httpClient.request<Array<CommodityCost>>(
      'post',
      `${this.basePath}/cp-insights/top-10-commodities-by-cost`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Get Top 15 damagers By Cost
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsTop15DamagersByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<DamagerCost>>;
  public cpInsightsTop15DamagersByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<DamagerCost>>>;
  public cpInsightsTop15DamagersByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<DamagerCost>>>;
  public cpInsightsTop15DamagersByCostPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);
    return this.httpClient.request<Array<DamagerCost>>(
      'post',
      `${this.basePath}/cp-insights/top-damagers`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the top 10 damages based on cost.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsTopDamagesPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<DamageCostContainer>>;
  public cpInsightsTopDamagesPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<DamageCostContainer>>>;
  public cpInsightsTopDamagesPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<DamageCostContainer>>>;
  public cpInsightsTopDamagesPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<DamageCostContainer>>(
      'post',
      `${this.basePath}/cp-insights/top-damages`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Total WorkOrders Count
   *
   * @param body An object of Filters filled from CP Insights Screen
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsWorkOrderCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<WorkOrders>;
  public cpInsightsWorkOrderCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<WorkOrders>>;
  public cpInsightsWorkOrderCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<WorkOrders>>;
  public cpInsightsWorkOrderCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<WorkOrders>(
      'post',
      `${this.basePath}/cp-insights/work-order-count`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the grid recovery cases count based on the provided filter.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsRecoveryCasesCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<number>;
  public cpInsightsRecoveryCasesCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<number>>;
  public cpInsightsRecoveryCasesCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<number>>;
  public cpInsightsRecoveryCasesCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<number>(
      'post',
      `${this.basePath}/cp-insights/recovery-cases-count`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the grid recovery cases based on the provided filter.
   *
   * @param body An object containing the filters from CP Insights Screen as well as grid related filters.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsRecoveryCasesPost(
    body?: InsightsRecoveryCaseFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<InsightsRecoveryCase>>;
  public cpInsightsRecoveryCasesPost(
    body?: InsightsRecoveryCaseFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<InsightsRecoveryCase>>>;
  public cpInsightsRecoveryCasesPost(
    body?: InsightsRecoveryCaseFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<InsightsRecoveryCase>>>;
  public cpInsightsRecoveryCasesPost(
    body?: InsightsRecoveryCaseFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<InsightsRecoveryCase>>(
      'post',
      `${this.basePath}/cp-insights/recovery-cases`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the grid recovery cases count based on the provided filter.
   *
   * @param body An object containing the filters from CP Insights Screen.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsCustomerCaseCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<number>;
  public cpInsightsCustomerCaseCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<number>>;
  public cpInsightsCustomerCaseCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<number>>;
  public cpInsightsCustomerCaseCountPost(
    body?: InsightsFilter,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<number>(
      'post',
      `${this.basePath}/cp-insights/customer-insights-count`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }

  /**
   * Retrieves the grid recovery cases based on the provided filter.
   *
   * @param body An object containing the filters from CP Insights Screen as well as grid related filters.
   * @param aPIVersion
   * @param idToken ID Token for authentication
   * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
   * @param reportProgress flag to report request and response progress.
   */
  public cpInsightsCustomerInsightsPost(
    body?: InsightsFilterV1,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'body',
    reportProgress?: boolean
  ): Observable<Array<CustomerInsights>>;
  public cpInsightsCustomerInsightsPost(
    body?: InsightsFilterV1,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'response',
    reportProgress?: boolean
  ): Observable<HttpResponse<Array<CustomerInsights>>>;
  public cpInsightsCustomerInsightsPost(
    body?: InsightsFilterV1,
    aPIVersion?: string,
    idToken?: string,
    observe?: 'events',
    reportProgress?: boolean
  ): Observable<HttpEvent<Array<CustomerInsights>>>;
  public cpInsightsCustomerInsightsPost(
    body?: InsightsFilterV1,
    aPIVersion?: string,
    idToken?: string,
    observe: any = 'body',
    reportProgress: boolean = false
  ): Observable<any> {
    let headers = this.defaultHeaders;
    if (aPIVersion !== undefined && aPIVersion !== null) {
      headers = headers.set('API-Version', String(aPIVersion));
    }
    if (idToken !== undefined && idToken !== null) {
      headers = headers.set('Id-Token', String(idToken));
    }

    // to determine the Accept header
    let httpHeaderAccepts: string[] = [
      'text/plain',
      'application/json',
      'text/json',
    ];
    headers = headers.set('Accept', httpHeaderAccepts);

    // to determine the Content-Type header
    const consumes: string[] = [
      'application/json',
      'text/json',
      'application/_*+json',
    ];
    headers = headers.set('Content-Type', consumes);

    return this.httpClient.request<Array<CustomerInsights>>(
      'post',
      `${this.basePath}/cp-insights/customer-insights-list`,
      {
        body: body,
        headers: headers,
        observe: observe,
        reportProgress: reportProgress,
      }
    );
  }
}
